module.exports = __webpack_public_path__ + "static/media/lift_weight.d8a44174.png";